import { Store } from 'pullstate';

const defaultState = {};

const zoneStore = new Store(defaultState);

export default zoneStore;

export const updateZoneStore = (values) => {
  // console.log('UPDATE STORE', values);
  const updatedValues = (s) => {
    Object.keys(values).forEach((key) => {
      s[key] = values[key];
    });
  };
  zoneStore.update(updatedValues);
};

export const resetStore = () => {
  updateZoneStore({ ...defaultState });
};
